import React, { Component } from "react";
import Headers from "../Layouts/HeaderReceptionist";
import axios from "axios";
// import NextOfKin from './NextOfKin';
import { useHistory } from "react-router-dom";
import $ from "jquery";
import { config } from "../_helpers/global";
import { NewbornSidebar } from "../Layouts/NewbornSidebar";

export class NewbornPhysicalExamination extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      vitalSigns: "",
      pulseRate: "",
      temperature: "",
      respirationRate: "",
      SPO2: "",
      response: "",
      loading: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.PrintWindow = this.PrintWindow.bind(this);
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  componentDidMount() {
    this.setState({
      uniqid: (Math.random() + 1).toString(36).substring(7),
    });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      "Access-Control-Allow-Origin": "*",
      visitid: localStorage.getItem("currentVisitId"),
    };
    event.preventDefault();
    let payload = {
      vitalSigns: this.state.vitalSigns,
      pulseRate: this.state.pulseRate,
      temperature: this.state.temperature,
      respirationRate: this.state.respirationRate,
      SPO2: this.state.SPO2,
    };

    // console.log(payload);

    axios
      .post(this.api_url+"newborn/physical", payload, {
        headers: headers,
      })
      .then((response) => {
        // console.log(response)
        this.setState({ response: response });
        if (response.status == 200) {
          $("#SubmitError").fadeOut("fast");
          $(".alert-success").show();
          setTimeout(function (props) {
            window.location.href = "/newbornunit/procedures";
          }, 1000);
        } else {
          $(".alert-success").fadeOut("fast");
          $("#SubmitError").show();
        }
      })
      .catch((error) => {
        this.state.loading = false;
        $(".alert-success").fadeOut("fast");
        $("#SubmitError").show();
        console.log(error);
      });
  };
  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    const {
      vitalSigns,
      pulseRate,
      temperature,
      respirationRate,
      SPO2,
      loading,
    } = this.state;

    return (
      <div>
        {/* <NextOfKin userData = {response}/> */}
        <Headers />
        <NewbornSidebar></NewbornSidebar>

        <main className="content-container">
          <div className="container p-2">
            <div className="row pl-5 text-lg-center font-weight-bold p-1">
              <p className="text-capitalize" style={font16}>
                Newborn Vital Signs
              </p>
            </div>
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Vital Signs
                    </h6>
                    <textarea
                      className="form-control"
                      onChange={this.handleChange}
                      value={vitalSigns}
                      name="vitalSigns"
                      type="text"
                      rows="3"
                      required
                    ></textarea>
                  </div>
                </div>
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Pulse Rate
                    </h6>
                    <textarea
                      className="form-control"
                      onChange={this.handleChange}
                      value={pulseRate}
                      name="pulseRate"
                      type="text"
                      rows="3"
                      required
                    ></textarea>
                  </div>
                </div>
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Temperature{" "}
                    </h6>
                    <textarea
                      className="form-control"
                      onChange={this.handleChange}
                      value={temperature}
                      name="temperature"
                      type="text"
                      rows="3"
                      required
                    ></textarea>
                  </div>
                </div>
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Respiration Rate{" "}
                    </h6>
                    <textarea
                      className="form-control"
                      onChange={this.handleChange}
                      value={respirationRate}
                      name="respirationRate"
                      type="text"
                      rows="3"
                      required
                    ></textarea>
                  </div>
                </div>
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      SPO2
                    </h6>
                    <textarea
                      className="form-control"
                      onChange={this.handleChange}
                      value={SPO2}
                      name="SPO2"
                      type="text"
                      rows="3"
                      required
                    ></textarea>
                  </div>
                </div>
              </div>

              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="SubmitSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details were saved Successfuly.
              </div>
              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <br />
                <br />
                <br />
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    {loading == false ? (
                      <span>Submit</span>
                    ) : (
                      <span>Loading</span>
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default NewbornPhysicalExamination;
